/**
 * This is the main entry point for webpack.
 * This file as an "autoloader" for any files placed under the "components/" directory
 * so just create the directory, place any component file in it, and it should be auto bundled.
 * The component file "can" have a default export as an object with a method init() that will be called on page load
 */

// register global variables
// window.$ = window.jQuery = require('jquery');
// import Vue from 'vue';
// window.Vue = Vue;

const axios = require('axios');
window.axios = axios;

import { _log, scrollToElement } from './helpers/util';


// window._log = _log;
// window.httpHuildQuery = httpHuildQuery;
// window.scrollToElement = scrollToElement;

import components from './components';

const app = {
    init() {
        for (let i in components) {
            let component = components[i];
            if (typeof component === 'object' && component.hasOwnProperty('default')) {
                const queryString = window.location.search;
                if (queryString.search('debug=npm') != -1) {

                    console.log('load: '+component.default.name);
                }

                component.default.hasOwnProperty('init') ? component.default.init() : null;
            }
        }
    }
};

app.init();